const { slideDown, slideUp, debounce } = window.BAO.Utils

class MobileAccordion extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'panel']
  }

  static get styles () {
    return `
      :host {
        display: block;

        overflow: hidden;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    this.panelHeight = this.getPanelHeight()

    this.activate()
  }

  activate () {
    if (!this.isOpen && this.isActive) {
      this.els.panel.element.style.height = `0`
    }
  }

  deactivate () {
    this.els.panel.element.removeAttribute('style')
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onWindowResize = this.onWindowResize.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.onTriggerClick)
    window.addEventListener('resize', debounce(this.onWindowResize, 200))
  }

  onTriggerClick (e) {
    if (!this.isActive) return

    e.preventDefault()

    document
      .querySelectorAll('mobile-accordion[open] .ft-Footer_Trigger')
      .forEach(el => {
        if (el === e.target.closest(this.els.trigger.selector)) return

        el.click()
      })

    this.isOpen = !this.isOpen
  }

  onWindowResize () {
    this.isActive ? this.activate() : this.deactivate()
  }

  getPanelHeight () {
    const panel = this.els.panel.element
    panel.style.display = 'block'

    const height = panel.offsetHeight
    panel.removeAttribute('style')

    return height + this.additionalHeight
  }

  get isActive () {
    const activeThreshold = Number(this.getAttribute('active-threshold')) || 980

    return window.innerWidth <= activeThreshold
  }

  get isOpen () {
    return this.hasAttribute('open')
  }

  set isOpen (val) {
    val ? this.setAttribute('open', '') : this.removeAttribute('open')

    val
      ? slideDown(this.els.panel.element, this.panelHeight, {
        speed: 100,
      })
      : slideUp(this.els.panel.element, this.panelHeight, {
        speed: 100,
      })

    this.els.panel.element.setAttribute('aria-expanded', val.toString())
  }

  get additionalHeight () {
    return Number(this.getAttribute('additional-height')) || 0
  }
}

if (!customElements.get('mobile-accordion')) {
  customElements.define('mobile-accordion', MobileAccordion)
}
